import getApi from '../../api'

export const closeOrdoclic = (ordoclicPatientIds: string[]) =>
  getApi().post<number[]>('external_eprescription/close', {
    ordoclicPatientIds,
  })
